import React from "react";
import { selectIcon, SVG } from "../UI/selector";
import Images from "../UI/Image/Image";
import { internet } from "../../services/Constants";

// let status = 1;

// export const CheckOnline = (props) =>  {
//     return(
//         <React.Fragment>
//             {props.children}
//         </React.Fragment>
//     );
// };

export const CheckOffline = (props) => {
  console.log("offline");
  return (
    <div className="offline">
      <Images src={internet.offline} />
      <span>Network connectivity lost</span>
    </div>
  );
};
